import React from "react"
import {
  Elements,
  ElementsConsumer,
  CardElement
} from "@stripe/react-stripe-js"
import { Summary } from "uikit"
import Loading from "components/Loading"

const INTERVAL_LABEL = {
  yearly: "year",
  monthly: "month"
}

function titleCase(string) {
  let title = string.toLowerCase().split(" ")
  for (let i = 0; i < title.length; i++) {
    title[i] = title[i][0].toUpperCase() + title[i].slice(1)
  }
  return title.join(" ")
}

export default class StripeCheckout extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      stripePromise: null
    }
  }

  componentDidMount = () => {
    import("@stripe/stripe-js").then(stripe => {
      this.setState({
        stripePromise: stripe.loadStripe(
          process.env.REACT_APP_DEPLOY_ENV === "production"
            ? "pk_live_otuu4ifrGS6Og9hSb2b21GlX"
            : "pk_test_Pg46MIodzJBOCIS5rUpXWy7s"
        )
      })
    })
  }

  render = () => {
    if (!this.state.stripePromise) {
      return <Loading />
    } else {
      return (
        <Elements stripe={this.state.stripePromise}>
          <ElementsConsumer>
            {({ elements, stripe }) => (
              <StripeCheckoutForm
                onSubmit={this.props.onSubmit}
                onCancel={this.props.onCancel}
                onSuccess={this.props.onSuccess}
                isUpgrade={this.props.isUpgrade}
                planName={titleCase(this.props.planName)}
                amount={this.props.amount}
                free_trial_days={this.props.free_trial_days}
                interval={this.props.interval}
                elements={elements}
                stripe={stripe}
              />
            )}
          </ElementsConsumer>
        </Elements>
      )
    }
  }
}

class StripeCheckoutForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      error: null,
      isComplete: false,
      isProcessing: false,
      hasSucceeded: false
    }
  }

  handleSubmit = async event => {
    // Block native form submission.
    event.preventDefault()
    this.setState({ isProcessing: true })

    const { stripe, elements } = this.props

    if (!stripe || !elements) {
      // Stripe.js has not loaded yet. Make sure to disable
      // form submission until Stripe.js has loaded.
      return
    }

    // Get a reference to a mounted CardElement. Elements knows how
    // to find your CardElement because there can only ever be one of
    // each type of element.
    const cardElement = elements.getElement(CardElement)

    const { error, token } = await stripe.createToken(cardElement)

    if (error) {
      this.setState({ error, isProcessing: false })
    } else {
      this.setState({ hasSucceeded: true })
      await this.props.onSubmit({ stripe_token: token.id })
    }
  }

  handleChange = event => {
    this.setState({ error: null })
    if (event.complete) {
      this.setState({ isComplete: true })
    }
  }

  render = () => {
    const {
      stripe,
      elements,
      planName,
      amount,
      free_trial_days,
      interval,
      onSuccess,
      onCancel,
      isUpgrade
    } = this.props
    if (this.state.hasSucceeded) {
      return onSuccess()
    } else {
      return (
        <Summary className="white">
          <Summary.Header
            heading={isUpgrade ? "Payment Method" : "Payment Authorization"}
            description={
              isUpgrade
                ? "A credit card is required to complete your plan change."
                : free_trial_days
                ? `You won't be charged until after your ${free_trial_days} day free trial ends.`
                : "You won't be charged until you've completed your sign-up."
            }
            style={{ paddingBottom: "1em" }}
          />
          <Summary.Body style={{ backgroundColor: "#F2F8FE" }}>
            <div
              style={{
                maxWidth: "400px",
                marginLeft: "auto",
                marginRight: "auto",
                marginTop: "2em",
                marginBottom: "4em"
              }}
            >
              <h4 style={{ textAlign: "center" }}>
                ${amount}/{INTERVAL_LABEL[interval]}
                <br />
                <span style={{ color: "#00adef" }}>{planName}</span>
              </h4>
              <div
                style={{
                  padding: "1em",
                  backgroundColor: "white"
                }}
              >
                {stripe && elements ? (
                  <CardElement
                    options={{
                      style: {
                        base: {
                          fontSize: "16px",
                          backgroundColor: "White",
                          color: "#424770",
                          letterSpacing: "0.025em",
                          "::placeholder": {
                            color: "#aab7c4"
                          }
                        },
                        invalid: {
                          color: "#9e2146"
                        }
                      }
                    }}
                    onChange={this.handleChange}
                  />
                ) : (
                  <div style={{ color: "#aab7c4", textAlign: "center" }}>
                    Loading...
                  </div>
                )}
              </div>
              {this.state.error ? (
                <div style={{ color: "red", marginTop: "0.25em" }}>
                  {this.state.error.message}
                </div>
              ) : null}
            </div>
          </Summary.Body>
          <Summary.Footer
            onSubmit={this.handleSubmit}
            onCancel={onCancel}
            nextStep={isUpgrade ? null : "Create User Profile"}
            submitButtonLabel={isUpgrade ? "Subscribe" : "Authorize"}
            disableSubmitButton={!this.state.isComplete}
            loading={this.state.isProcessing}
            light
          />
        </Summary>
      )
    }
  }
}
